export default "__VITE_ASSET__Cd6hX258__"